<template>
  <b-input-group>
    <b-form-input v-model="local_value" :disabled="!in_edition || disabled" />
    <b-input-group-append v-if="!disabled">
      <b-button @click="toggle_edition()" variant="outline-secondary">
        <span v-if="in_edition" class="fas fa-check fa-xs fa-fw" />
        <span v-else class="fas fa-pen fa-xs fa-fw" />
      </b-button>
      <b-button
        v-if="in_edition"
        @click="cancel_edition()"
        variant="outline-secondary"
      >
        <span class="fas fa-times fa-xs fa-fw" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import _ from 'lodash'

// *****************************************************************************

export default {
  name: 'Renamer',
  components: {},
  props: ['value', 'disabled'],
  data() {
    return {
      local_value: '',
      in_edition: false,
    }
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.local_value = nv
        }
      },
    },
  },

  methods: {
    toggle_edition() {
      if (this.local_value != '') {
        this.$emit('input', this.local_value)
        this.in_edition = !this.in_edition
      }
    },
    cancel_edition() {
      this.local_value = this.value
      this.in_edition = !this.in_edition
    },
  },
}
</script>
